import { Component, Inject, Input, OnInit } from '@angular/core';
import { APP_CONFIG } from '../../../app.config';
import { AppEnvironmentModel } from '../../../components/visum-erfassung/angaben-zur-person/stell-vertreter/stell-vertreter.component';
import { AppConfig } from '../../../models/config/app-config';
import { AppControl } from '../components.model';

@Component({
  selector: 'app-checkbox-group',
  templateUrl: './checkbox-group.component.html',
  styleUrl: './checkbox-group.component.scss'
})
export class CheckboxGroupComponent implements OnInit {

  @Input({required: true}) checkboxes: Array<AppControl> = [];
  @Input() textPrefix = "";
  model: AppEnvironmentModel;

  constructor(@Inject(APP_CONFIG) protected appConfig: AppConfig) {}

  ngOnInit() {
    this.model = {
      isMek: this.appConfig.umgebung === 'MEK',
      isVidex: this.appConfig.umgebung === 'VIDEX',
      isCVisum: this.appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT',
      isDVisum: this.appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'
    };
  };

  getLabelTextKey(controlName: string) {
    return this.textPrefix + controlName;
  }

  getAssistanceTextKey(controlName: string) {
    return this.getLabelTextKey(controlName) + "_assistance";
  }
}
